/**
 * Navigate away while keeping the caller's async submit handler pending.
 *
 * `window.location.assign` returns immediately — before the document unloads.
 * If the submit handler resolves at that point, react-hook-form clears
 * `isSubmitting` and the button spinner flickers off before redirect.
 * Returning a never-settling promise keeps `isSubmitting` true until unload.
 */
export function assignAndKeepSubmitting(url: string): Promise<never> {
  window.location.assign(url);
  return new Promise<never>(() => {});
}
